import type { InputHTMLAttributes } from 'react';

interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  error?: string | null;
}

export function Input({ label, error, id, style, ...rest }: InputProps) {
  const inputId = id ?? rest.name;
  return (
    <label style={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
      {label && <span style={{ fontSize: 'var(--fs-body)', color: '#bbb' }}>{label}</span>}
      <input
        id={inputId}
        {...rest}
        style={{
          padding: '8px 12px',
          borderRadius: 6,
          border: `1px solid ${error ? '#e74c3c' : 'rgba(15,45,100,0.5)'}`,
          background: 'rgba(255,255,255,0.04)',
          color: 'var(--text)',
          fontSize: 'var(--fs-body)',
          minHeight: 40,
          outline: 'none',
          ...style,
        }}
      />
      {error && <span style={{ fontSize: 'var(--fs-small)', color: '#e74c3c' }}>{error}</span>}
    </label>
  );
}
